import { NgModule } from '@angular/core';
import { AuthGuard } from '../auth/auth.guard';
import { ModalsModule } from '../modals/modals.module';
import { CommonModule } from '@angular/common';
import { EmailService } from './email.service';
import { PluginsService } from '../plugins/plugins.service';
import { CustomizationService } from '../customization/customization.service';
import { EmailComponent } from './email.component';
import { EmailEditorComponent } from './editor/editor.component';
import { EmailEditorComponent2 } from './editor-2/editor.component';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { EditCampaignComponent } from './campaigns/edit-campaign/edit-campaign.component';
import { EmailJobsComponent } from './campaigns/email-jobs/email-jobs.component';
import { OndemandEditorComponent } from './ondemand-editor/ondemand-editor.component';
import { SegmentsComponent } from './segments/segments.component';
import { SegmentSelectComponent } from './segments/segment-select/segment-select.component';
import { SegmentEditComponent } from './segments/segment-edit/segment-edit.component';
import { EditCampaignContentComponent } from './campaigns/edit-campaign-content/edit-campaign-content.component';
import { CampaignsService } from '../sessions/campaigns.service';
import { OndemandEmailService } from '../sessions/ondemand-email.service';
import { IcsService } from '../sessions/ics.service';
import { EditIcsContentComponent } from './edit-ics-content/edit-ics-content.component';
import { SegmentsService } from '../sessions/segments.service';
import { UsersService } from '../sessions/users/users.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgxEditorModule } from 'ngx-editor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { TagEditorModule } from '../tag-editor/tag-editor.module';
import { EvaEditorModule } from '../eva-editor/eva-editor.module';
import { TagsFormatService } from '../tags/tags-format.service';
import { ValidateImportService } from './editor/validate.import.service';
import { BlockHeaderComponent } from '../block-header/block-header.component'
import { SimpleFileUploadComponent } from '../sessions/file-upload/simple-file-upload.component'
import { FileUploadModule } from 'ng2-file-upload';
import { DatePickerModule } from '../date-picker/date-picker.module';

@NgModule({
  declarations: [EmailComponent, EmailEditorComponent, EmailEditorComponent2, BlockHeaderComponent, SimpleFileUploadComponent, CampaignsComponent, EditCampaignComponent, EmailJobsComponent, OndemandEditorComponent, SegmentsComponent, SegmentSelectComponent, SegmentEditComponent, EditCampaignContentComponent, EditIcsContentComponent],
  exports: [EmailComponent, EmailEditorComponent, CampaignsComponent, EditIcsContentComponent],
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule, NgxEditorModule, ModalsModule, TagEditorModule, EvaEditorModule, FileUploadModule, DatePickerModule, SharedModule],
  providers: [AuthGuard, EmailService, CustomizationService, TagsFormatService, PluginsService, ValidateImportService, CampaignsService, OndemandEmailService, IcsService, UsersService, SegmentsService],
  entryComponents: []
})
export class EmailModule {}



// WEBPACK FOOTER //
// ./src/app/modules/email/email.module.ts